export const COLUMN_WIDTHS: Record<string, number> = {
  condition_name: 300,
  official_name: 300,
  condition_type: 300,
  start_date: 150,
  end_date: 150,
  current_conmed_yn: 250,
  DEFAULT: 130,
};

export const TITLE_MAPPING: Record<string, string> = {
  official_name: "Official Name",
  current_conmed_yn: "Is medication currently taken for this condition?",
  start_date_raw: "MH Start Date (Raw)",
  end_date_raw: "MH End Date (Raw)",
  subject: "Subject ID",
  birth_date: "DOB",
  study_arm_label: "Study Arm",
  site: "Site ID",
  participant_id: "Participant ID",
};

export const COLUMNS_WITH_ELLIPSIS = new Set([
  "condition_name",
  "official_name",
]);

export const SEARCHABLE_COLUMNS = new Set([
  "condition_name",
  "official_name",
  "start_date",
  "end_date",
]);

export const DEFAULT_HIDDEN_COLUMNS = new Set([
  "subject",
  "participant_id",
  "sex",
  "birth_date",
  "indication",
  "study_arm_label",
  "subject_group",
  "site",
  "country",
  "mhyn",
  "study_status",
  "severity_source_value",
]);

export const FIXED_COLUMNS = new Set(["condition_name"]);
